import { futureValueSIP, sipPlusStpFutureValue } from "../../engine/calculations";

const fvSipPlusStpConfig = {
  key: "fv-sip-plus-stp",
  title: "Future Value of SIP + STP",
  category: "Growth",
  description: "Combine a direct monthly SIP with a separate Systematic Transfer Plan leg.",
  fields: [
    { key: "monthly", label: "Direct monthly SIP", type: "currency", default: 10_000, min: 0, max: 10_00_000, help: "Invested straight into the target fund." },
    { key: "sipMonths", label: "Direct SIP period (months)", type: "number", default: 120, min: 1, max: 480 },
    { key: "monthlyTransfer", label: "Monthly STP transfer", type: "currency", default: 15_000, min: 0, max: 10_00_000 },
    { key: "stpMonths", label: "STP period (months)", type: "number", default: 36, min: 1, max: 480 },
    { key: "sourceRate", label: "Source fund return", type: "percent", default: 7, min: 0, max: 20, assumptionKey: "debtReturn" },
    { key: "targetRate", label: "Target fund return", type: "percent", default: 12, min: 0, max: 30, assumptionKey: "equityReturn" },
  ],
  chart: {
    type: "bar",
    xKey: "name",
    series: [{ key: "amount", label: "Amount", colorVar: "--gold" }],
  },
  compute(values) {
    const monthly = Number(values.monthly) || 0;
    const sipMonths = Math.round(Number(values.sipMonths) || 0);
    const monthlyTransfer = Number(values.monthlyTransfer) || 0;
    const stpMonths = Math.round(Number(values.stpMonths) || 0);
    const sourceRate = (Number(values.sourceRate) || 0) / 100;
    const targetRate = (Number(values.targetRate) || 0) / 100;

    const directSipFV = futureValueSIP(monthly, targetRate, sipMonths);
    const totalFV = sipPlusStpFutureValue(monthly, sourceRate, targetRate, sipMonths, monthlyTransfer, stpMonths);
    const stpLegFV = totalFV - directSipFV;

    return {
      headline: { label: "Combined Future Value", value: totalFV },
      breakdown: [
        { label: "From the direct SIP", value: directSipFV },
        { label: "From the STP leg", value: stpLegFV },
      ],
      series: [
        { name: "Direct SIP", amount: directSipFV },
        { name: "STP leg", amount: stpLegFV },
      ],
    };
  },
};

export default fvSipPlusStpConfig;
